<template>
  <div>
    <div class="form-container ou-donation-form jlic-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount:">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <AmountSelector />
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency:">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthlyText="Monthly" />
            </div>
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>             
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
          <FormRow>
          <Receipt :receipts="['us', 'israel']"/>
          </FormRow>          
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    const params = queryParams();

    if (params.code) {
      //@ts-ignore
      if (params.code === "support") {
        setValue("applications.0.campaign", "ADM JLIC Campaign");
        setValue("applications.0.subCampaign", "Direct Mail");
      } else if(params.code === "supportus"){
        setValue("applications.0.campaign", "ADM JLIC Campaign");
        setValue("applications.0.subCampaign", "Telemarketing");
      } else {
        setValue("applications.0.campaign", "general");
      }
    }


    return {
      form,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

.jlic-donation-form ::v-deep {
  h2 {
    border-bottom: 1px solid #ccc;
    display: block;
    width: 100%;
    padding: 0;
    margin-bottom: 25px;
    font-size: 24px;
    line-height: inherit;
    color: #333333;
    text-transform: none;
    letter-spacing: 0px;
    font-family: inherit;
    @media (min-width: 720px) {
      margin-top: 30px;
    }

    &::before {
      content: none;
    }
  }
  .styled-radio.styled-radio--ou-donation.row,
  .styled-radio-container.styled-radio-container--ou-donation.row {
    label {
      background: #aaa;
      color: white;
      width: 100%;
      text-align: center;
      border-radius: 2px;
      border: 1px solid #999;
      &:hover {
        background: #999;
      }
    }

    input[type="radio"]:checked + label {
      background: #bf1b31;
    }
    // input[type="radio"]:checked + label .label-amount {
    //   background: #0d346c;
    //   border-color: #0d346c;
    // }
  }
}
</style>
